import React, { useCallback, useRef, useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { FiCheck, FiX } from 'react-icons/fi';
import useSWR, { mutate as mutateGlobal } from 'swr';
import * as Yup from 'yup';
import { Form } from '@unform/web';

import getValidationErrors from '../../../utils/getValidationErrors';
import api from '../../../services/api';

import { useToast } from '../../../hooks/toast';

import NavBarMenu from '../../../components/NavbarMenu';
import ContainerBox from '../../../components/ContainerBox';
import { Input, CheckBox } from '../../../components/Form';
import ButtonSave from '../../../components/ButtonPrimaryBlue';
import ButtonCancel from '../../../components/ButtonCancel';

import { ButtonGroup, Wrapper } from './styles';

const DreGroupsNewEdit = () => {
  const { data } = useSWR('coastcenters');

  const [id, setId] = useState(null);
  const [coastDefault, setCoastDefault] = useState(false);

  const location = useLocation();

  const history = useHistory();

  const formRef = useRef(null);
  const { addToast } = useToast();

  useEffect(() => {
    if (!location.state) {
      return;
    }

    setId(location.state.item.id);
    formRef.current.setData(location.state.item);
    setCoastDefault(location.state.coast_center_default);
  }, [location.state, coastDefault]);

  useEffect(() => {
    const nameInput = formRef.current.getFieldRef('name');

    nameInput.focus();
  }, []);

  const handleSubmit = useCallback(
    async (dataForm) => {
      try {
        formRef.current.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Nome Centro de custo é obrigatório'),
        });

        await schema.validate(dataForm, {
          abortEarly: false,
        });

        const response = await api.get('coastcenterdefault');

        if (response.data.id && dataForm.coast_center_default) {
          addToast({
            type: 'error',
            title: 'Já existe um Centro de Custo Padrão.',
            description: 'Só pode ter um por padrão',
          });
          return;
        }

        mutateGlobal(`/coastcenters?page=1`, [...data, dataForm], false);

        await api.post('coastcenters', dataForm);

        addToast({
          type: 'success',
          title: 'Cadastro efetuado com Sucesso',
        });

        history.push('/coastcenters');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current.setErrors(errors);
          return;
        }

        if (err.response.status === 403) {
          addToast({
            type: 'error',
            description: 'Centro de Custo já cadastrado',
          });
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description: 'Verifique os dados.',
        });
      }
    },
    [addToast, history, data]
  );

  const handleUpdate = useCallback(
    async (dataForm) => {
      try {
        formRef.current.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Nome Centro de custo é obrigatório'),
        });

        await schema.validate(dataForm, {
          abortEarly: false,
        });

        const response = await api.get('coastcenterdefault');

        if (
          response.data.id &&
          response.data.id !== id &&
          dataForm.coast_center_default
        ) {
          addToast({
            type: 'error',
            title: 'Já existe um Centro de Custo Padrão.',
            description: 'Só pode ter um por padrão',
          });
          return;
        }

        if (dataForm.coast_center_default && response.data.id) {
          if (response.data.id !== id) {
            addToast({
              type: 'error',
              title: 'Já existe um centro de custo Padrão.',
              description:
                'Só pode ter um centro de custo padrão para movimento',
            });
            return;
          }
        }

        await api.patch(`coastcenters/${id}`, dataForm);

        mutateGlobal(`coastcenters/${id}`, dataForm);

        addToast({
          title: 'Cadastro alterado com Sucesso',
        });

        history.push('/coastcenters');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current.setErrors(errors);
          return;
        }

        if (err.response.status === 403) {
          addToast({
            type: 'error',
            description: 'Nome Centro de custo já cadastrado',
          });
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description: 'Verifique os dados.',
        });
      }
    },
    [addToast, history, id]
  );
  return (
    <>
      <NavBarMenu />

      <ContainerBox
        title={
          location.state
            ? 'Alterar Centro de Custo'
            : 'Cadastro de Centro de Custo'
        }
        small
      >
        <Form
          initialData={location.state ? location.state.item : {}}
          ref={formRef}
          onSubmit={location.state ? handleUpdate : handleSubmit}
        >
          <Wrapper>
            <Input
              id="name"
              name="name"
              label="Centro de  Custo*"
              autoComplete="off"
            />
            <CheckBox
              style={{ marginBottom: 32, fontWeight: 'normal' }}
              id="coast_center_default"
              name="coast_center_default"
              label="Centro de Custo Padrão"
              title="Centro de custo de lançamentos financeiros"
            />
          </Wrapper>
          <ButtonGroup>
            <ButtonSave icon={FiCheck}>Salvar</ButtonSave>
            <Link to="/coastcenters">
              <ButtonCancel icon={FiX}>Cancelar</ButtonCancel>
            </Link>
          </ButtonGroup>
        </Form>
      </ContainerBox>
    </>
  );
};

export default DreGroupsNewEdit;
